import { Box } from '@amzn/awsui-components-console';
import moment from 'moment';
import { useIntl } from 'react-intl';

import { LabCard, JamCard } from '@/components/labCard/LabCard';

import messages from './LabList.messages';

import './LabList.css';

const translateDurationUnit = (value, unit, locale) => {
    // crlalva: to match Content API duration enum
    // https://code.amazon.com/packages/BunsenContent/blobs/mainline/--/src/libraries/data/blueprintVersionEnums.js
    if (unit === 'min') {
        unit = 'minute';
    }
    return moment.duration(value, unit).locale(locale).humanize();
};

const LabListBase = ({ children, label, description }) => {
    return (
        <>
            {description ? <Box variant='p'>{description}</Box> : null}
            <Box data-testid='lab-list-base'>
                {label ? <Box variant='awsui-key-label'>{label}</Box> : null}
                {children}
            </Box>
        </>
    );
};

export const LabList = ({ labs = [], title, description }) => {
    const { locale, formatMessage } = useIntl();

    const formattedLabs = labs.map((content, index) => ({
        ...content,
        index,
        title: content.title.replace(new RegExp(`^\\s*${title}\\s*-\\s*`), ''),
        duration: translateDurationUnit(content.duration, content.durationUnit || 'minute', locale),
    }));

    return formattedLabs.length ? (
        <LabListBase description={description} label={formatMessage(messages.labsHeaderLabel)}>
            <ol className='lab-list'>
                {formattedLabs.map((lab) => (
                    <LabCard {...lab} key={lab.title} />
                ))}
            </ol>
        </LabListBase>
    ) : null;
};

export const JamList = ({ title, jamTrainings = [] }) => {
    const { formatMessage } = useIntl();
    return jamTrainings.length ? (
        <LabListBase label={formatMessage(messages.jamHeaderLabel)}>
            {jamTrainings.map((training, index) => (
                <JamCard
                    courseTitle={title}
                    jamIndex={index}
                    jamTraining={training}
                    key={training.contentId}
                />
            ))}
        </LabListBase>
    ) : null;
};
